import angular from 'angular';
import { alerts } from 'app/components/global';
import {
  ssDialogService,
  loaderService,
  vmDataService
} from 'app/services';
import uniqueVendorNameValidator from './master-vendor-unique-name.directive';
import controller from './edit-master-vendor-dialog.controller';
import template from './edit-master-vendor-dialog.html';
import masterVendorCityMessagesTpl from './messages/master-vendor.city.messages.html';
import masterVendorNameMessagesTpl from './messages/master-vendor.name.messages.html';
import masterVendorStreetMessagesTpl from './messages/master-vendor.street.messages.html';
import masterVendorZipMessagesTpl from './messages/master-vendor.zip.messages.html';
import masterVendorSuiteMessagesTpl from './messages/master-vendor.suite.messages.html';

export class dialogService {
  getOptions($event, { masterVendor = null }) {
    return {
      controller,
      controllerAs: 'editMasterVendorDialogVM',
      locals: {
        masterVendor,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.vendorManagementAdmin.editMasterVendorDialog', [
  alerts,
  ssDialogService,
  loaderService,
  vmDataService,
])
  .service('editMasterVendorDialog', dialogService)
  .directive('vmaMasterVendorUniqueName', uniqueVendorNameValidator)
  .run(($templateCache) => {
    $templateCache.put('master-vendor.city.messages.html', masterVendorCityMessagesTpl);
    $templateCache.put('master-vendor.name.messages.html', masterVendorNameMessagesTpl);
    $templateCache.put('master-vendor.street.messages.html', masterVendorStreetMessagesTpl);
    $templateCache.put('master-vendor.zip.messages.html', masterVendorZipMessagesTpl);
    $templateCache.put('master-vendor.suite.messages.html', masterVendorSuiteMessagesTpl);
  })
  .name;

console.log('app.components.admin.vendorManagementAdmin.editMasterVendorDialog created');
